import Input from './Input';
import MessageAgent from './MessageAgent';
import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import MessageClient from './MessageClient';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoading as selectIsLoading,
  selectResponse,
  selectThank,
  selectWait,
} from '../../redux/messages/selectors';
import { addThank, addWait, delThankAndWait } from '../../redux/messages/slice';

const AgentTraining = () => {
  const [userCode, setUserCode] = useState(null);
  const dispatch = useDispatch();
  const thank = useSelector(selectThank);
  const wait = useSelector(selectWait);
  const isLoading = useSelector(selectIsLoading);
  const response = useSelector(selectResponse);

  const sendAwait = () => {
    setTimeout(() => {
      dispatch(addThank());
    }, 1500);
    setTimeout(() => {
      dispatch(addWait());
    }, 3000);
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
    dispatch(delThankAndWait());
  }, [dispatch]);

  return (
    <div className="flex flex-col justify-between  w-full h-full md:pl-24 p-4 pt-20">
      <div className="flex flex-col gap-2 mb-auto h-full overflow-y-scroll  pb-10 ">
        <MessageAgent />
        {userCode && <MessageClient>{userCode}</MessageClient>}
        {isLoading && sendAwait()}

        {thank && <MessageAgent>{thank}</MessageAgent>}
        {wait && <MessageAgent>{wait}</MessageAgent>}
        {thank && wait && response && (
          <MessageAgent typing="text-pretty" animation={true}>
            {response}
          </MessageAgent>
        )}
      </div>

      <div className=" bottom-3 w-auto mt-auto">
        <Input setUserCode={setUserCode} />
      </div>
    </div>
  );
};

export default AgentTraining;
